module.exports = __webpack_public_path__ + "img/carousel-clientes-7.7233e83c.png";